/**
 * @module tizen/playerManager
 * @private
 */

// TODO Move to config
const languagesMap = {
  eng: "en",
  english: "en",
  ara: "ar",
  arabic: "ar",
  fra: "fr",
  french: "fr"
};

const originalLanguagesMap = {
  en: "English",
  eng: "English",
  und: "English",
  ar: "Arabic",
  ara: "Arabic",
  fr: "French",
  fre: "French",
  ja: "Japanese",
  jp: "Japanese",
  jpn: "Japanese",
  ko: "Korean",
  kor: "Korean",
  tr: "Turkish",
  tur: "Turkish",
  ur: "Urdu",
  urd: "Urdu",
  fa: "Persian",
  fas: "Persian"
};

/**
 * Ensures that the returned track contains always the same convention for the language property. The tracks can come
 * with different values for the same language. For example, english tracks can have 'en' or 'eng' value in the language
 * property. This function returns always the 2 character version of the language.
 * @param {string} language The language property present in the video player track
 * @returns {string} The 2 character language code of the found language or the language as it was received if there was
 * no translation found.
 */
export function normalizeLanguage(language) {
  return languagesMap[language] || language;
}

/**
 * Transforms the track object returned by the Tizen player to the standard track object exposed by the SDK. Basically,
 * it moves the language property from extra_info object to a property called language.
 * @param {Object} track Track object returned by Tizen video player, it can be an audio, subtitle or video track.
 * @returns {{index: *, type: *, language: *, data: {}|extra_info}} The standard track object exposed by the SDK
 */
export function transformTrack(track) {
  const trackExtraInfo = JSON.parse(track.extra_info);
  return {
    index: track.index,
    type: track.type,
    language: normalizeLanguage(trackExtraInfo.track_lang || trackExtraInfo.language),
    data: track.extra_info
  };
}

/**
 * Returns original version of the language (version that webmaf returns on getAudioTracks event).
 * @param {string} language The normalized language property
 * @returns {string} The original language code
 */
export function getOriginalLanguage(language) {
  return originalLanguagesMap[language] || language;
}
